import { BankOutlined, DollarOutlined, ToolOutlined } from '@ant-design/icons'
import FormCard from '@components/FormCard'
import Page from '@components/Page/Page'
import { useAppSelector } from '@store/hooks'
import { selectSelectedProgram } from '@store/membership/ProgramReducer'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Col, Row } from 'antd'

const PaymentSettingsTab = () => {
  const program = useAppSelector(selectSelectedProgram())

  if (!program) {
    return <></>
  }

  return (
    <Page>
      <Row gutter={[32, 32]}>
        <Col span={12}>
          <FormCard
            title="Currency"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['currency']}
            icon={<DollarOutlined />}
          />
        </Col>
        <Col span={12}>
          <FormCard
            title="Payment integration"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['paymentIntegration']}
            icon={<ToolOutlined />}
          />
        </Col>
        <Col span={24}>
          <FormCard
            title="Bank transfer"
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['bankTransfer']}
            icon={<BankOutlined />}
          />
        </Col>
      </Row>
    </Page>
  )
}

export default PaymentSettingsTab
